export default __webpack_public_path__ + "static/bg-flow-de9d6f3b4d44d2122b69f71cb6dd61a9.jpeg";